/** Number and date formatting. Icelandic convention: 1.234.567 kr., decimal comma. */

export function fmt(n: number): string {
  return `${Math.round(n).toLocaleString('de-DE')} kr.`;
}

/** Hours with at most two decimals, decimal comma. */
export function fmtH(n: number): string {
  return (Math.round(n * 100) / 100).toLocaleString('de-DE');
}

export function fmtPct(n: number): string {
  return `${n.toLocaleString('de-DE')}%`;
}

/** `2026-08-04` → `4.8.` */
export function fmtDay(ds: string): string {
  return `${Number(ds.slice(8))}.${Number(ds.slice(5, 7))}.`;
}

/** `2026-08-04` → `4.8.2026` */
export function fmtDate(ds: string): string {
  return `${Number(ds.slice(8))}.${Number(ds.slice(5, 7))}.${ds.slice(0, 4)}`;
}

/** `1.8.–31.8.` */
export function fmtSpan(from: string, to: string): string {
  return `${fmtDay(from)}–${fmtDay(to)}`;
}

/** Elapsed seconds as `HH:MM:SS`. */
export function fmtClock(hours: number): string {
  const s = Math.max(0, Math.floor(hours * 3600));
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(Math.floor(s / 3600))}:${p(Math.floor(s / 60) % 60)}:${p(s % 60)}`;
}

/** `2026-08-06T14:32:10Z` → `2026-08-06 14:32` in local time. */
export function fmtTs(ts: string): string {
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return ts;
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

export function fmtTime(ts: string): string {
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return '';
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(d.getHours())}:${p(d.getMinutes())}`;
}
